import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";
import "./styles.scss";

export const FieldInput = ({ label, name, ...props }) => (
  <>
    {label && <label>{label}</label>}
    <Field name={name} {...props} className="fa_form_input" />
    <ErrorMessage component="span" name={name} className="error_feedback" />
  </>
);

FieldInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["email", "text"]),
  as: PropTypes.oneOf(["textarea"]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};
